import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { supportRouteI18n } from '../i18n/support-route-i18n';

export function supportRoutePath(): string {
  return `/${langRouteI18n()}/${supportRouteI18n()}`;
}
